// @mui material components
import {
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
} from "@mui/material";

import MDBox from "theme/components/MDBox";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";
import { useState } from "react";
import axios from "axios.js";
import Editor from "react-simple-wysiwyg";
import MDTypography from "components/MDTypography";
// import AppConfig from "appConfig";

function MessageDialog(payload) {
  const {
    destinationType,
    destinationKey,
    description,
    setDisplayState,
    displayState = false,
  } = payload;
  // const [showMessageDialog, setShowMessageDialog] = useState(false);

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [subject, setSubject] = useState(null);
  const [messageBody, setMessageBody] = useState(null);

  async function sendMessage() {
    if (subject === null) {
      setSeverity("error");
      setErrMsg("Subject is required");
      setOpen(true);
      return;
    }

    if (messageBody === null) {
      setSeverity("error");
      setErrMsg("Message body is required");
      setOpen(true);
      return;
    }

    setDisplayState(false);
    setShowLoading(true);

    const json = {
      destination_type: `${destinationType}`,
      destination_key: `${destinationKey}`,
      subject: `${subject}`,
      message_body: messageBody,
    };

    await axios
      .post("agents/teams/messages/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={displayState}>
        <DialogTitle>
          <MDBox>Send Message</MDBox>
          <MDTypography variant="caption" fontWeight="light">
            {description}
          </MDTypography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDBox>
              <MDBox mt={2}>
                <MDInput
                  name="title"
                  margin="dense"
                  label="Subject"
                  type="text"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setSubject(e.target.value)}
                />
              </MDBox>
              <MDBox mt={3}>
                <Editor
                  value={messageBody}
                  onChange={(e) => setMessageBody(e.target.value)}
                  placeholder="Message body"
                />
              </MDBox>
            </MDBox>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setDisplayState(false);
            }}
            color="dark"
            variant="outlined"
          >
            Close
          </MDButton>
          <MDButton
            onClick={() => {
              sendMessage();
            }}
            color="success"
            variant="outlined"
          >
            Send
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default MessageDialog;
